module.exports = __webpack_public_path__ + "static/img/KZ.47db82bc.png";